var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function (resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator['throw'](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = this && this.__generator || function (thisArg, body) {
    var _ = {
            label: 0,
            sent: function () {
                if (t[0] & 1)
                    throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
    return g = {
        next: verb(0),
        'throw': verb(1),
        'return': verb(2)
    }, typeof Symbol === 'function' && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f)
            throw new TypeError('Generator is already executing.');
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [
                        op[0] & 2,
                        t.value
                    ];
                switch (op[0]) {
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [0];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2])
                        _.ops.pop();
                    _.trys.pop();
                    continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import React, {
    useEffect,
    useRef,
    useState
} from 'react';
import {
    Button,
    Modal,
    Carousel,
    Typography,
    Flex
} from '@one/haven-design';
import classNames from 'classnames';
import $http, { Q } from '@http';
import { UserAction } from '@common/enums/copilot';
import { isMobile } from '@common/utils';
import { RES_PATH } from '@common/config';
import AidenIcon from '../../UI/sources/svg/aiden.svg';
var LAST_STEP_INDEX = 2;
var CopilotGuide = function (props) {
    var _a;
    var _b = useState(false), guideVisible = _b[0], setGuideVisible = _b[1];
    var guideNextRef = useRef(null);
    var currentStepRef = useRef(0);
    var _c = useState('Next'), stepText = _c[0], setStepText = _c[1];
    var prefixCls = 'aiden';
    var clickGuideNext = function () {
        setTimeout(function () {
            if (currentStepRef.current === LAST_STEP_INDEX) {
                closeBanner();
                setGuideVisible(false);
            }
        }, 30);
    };
    var getShowPopover = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                case 0:
                    return [
                        4,
                        Q($http.get('/dashboard/IsUserClosedBanner?type=' + UserAction.CloseBanner))
                    ];
                case 1:
                    data = _a.sent();
                    setGuideVisible(!data);
                    return [2];
                }
            });
        });
    };
    var closeBanner = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                $http.post('/dashboard/CloseBanner', { type: UserAction.CloseBanner });
                return [2];
            });
        });
    };
    useEffect(function () {
        getShowPopover();
    }, []);
    useEffect(function () {
        var _a, _b;
        if (guideVisible) {
            (_a = guideNextRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('click', clickGuideNext);
        } else {
            (_b = guideNextRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', clickGuideNext);
        }
    }, [guideVisible]);
    return React.createElement(Modal, {
        tag: 'Copilot_GuideModal',
        zIndex: 1040,
        centered: true,
        title: 'Aiden Guide',
        maskClosable: true,
        open: guideVisible,
        className: classNames(prefixCls + '-guide-modal', (_a = {}, _a[prefixCls + '-guide-mobile-modal'] = isMobile, _a)),
        footer: null
    }, React.createElement(Carousel, {
        className: prefixCls + '-guide-carousel',
        tag: 'carousel',
        arrows: true,
        prevArrow: null,
        nextArrow: React.createElement(Button, {
            ref: guideNextRef,
            tag: 'Copilot_GuideModal_Next',
            type: 'primary'
        }, stepText),
        afterChange: function (current) {
            currentStepRef.current = current;
            setStepText(current === LAST_STEP_INDEX ? 'Done' : 'Next');
        }
    }, aidenSteps.map(function (step, idx) {
        return React.createElement(React.Fragment, { key: idx }, step);
    })));
};
var Step1Src = RES_PATH + 'sources/video/aiden-guide-step1.mp4';
var Step2Src = RES_PATH + 'sources/video/aiden-guide-step2.mp4';
var Step3Src = RES_PATH + 'sources/img/aiden-guide-step3.png';
var aidenSteps = [
    React.createElement('div', {
        key: 'step1',
        style: { padding: '24px 20px' }
    }, React.createElement('div', { style: { textAlign: 'center' } }, React.createElement('video', {
        src: Step1Src,
        width: 382,
        height: 220.33,
        autoPlay: true,
        controls: false,
        loop: true,
        muted: true,
        style: { maxWidth: '100%' }
    })), React.createElement(Flex, {
        vertical: true,
        gap: 16,
        style: { marginTop: '32px' }
    }, React.createElement(Flex, {
        gap: 6,
        align: 'baseline',
        justify: 'center'
    }, React.createElement(Typography.Title, {
        level: 4,
        color: 'colorGray9DarkBg',
        style: { fontFamily: '"Satoshi", sans-serif' }
    }, 'Introducing'), React.createElement('img', {
        style: {
            width: '66px',
            height: '20px'
        },
        src: AidenIcon
    })), React.createElement('div', {
        style: {
            lineHeight: 1,
            padding: '0 12px'
        }
    }, React.createElement(Typography.Text, { style: { color: '#000' } }, 'Your new AI assistant who is always here to help with your home\'s maintenance needs.'), React.createElement('br', null), React.createElement('br', null), React.createElement(Typography.Text, { style: { color: '#000' } }, 'Available 24/7/365 in whatever language is most comfortable for you, Aiden responds instantly \u2014 no call centers, no hold times.')))),
    React.createElement(Flex, {
        key: 'step2',
        align: 'center',
        gap: 12,
        style: { padding: '48px 0 24px 10px' }
    }, React.createElement('video', {
        src: Step2Src,
        width: 191,
        autoPlay: true,
        controls: false,
        loop: true,
        muted: true
    }), React.createElement(Flex, {
        vertical: true,
        gap: 16
    }, React.createElement(Typography.Title, {
        level: 4,
        color: 'colorGray8TextDefault',
        style: {
            fontWeight: 500,
            fontFamily: '"Satoshi", sans-serif',
            lineHeight: '120%'
        }
    }, 'The ', React.createElement('b', { style: { color: '#090909' } }, 'fastest'), ' and ', React.createElement('b', { style: { color: '#090909' } }, 'most accurate'), ' way to create a service request'), React.createElement('div', {
        style: {
            paddingRight: '32px',
            lineHeight: 1
        }
    }, React.createElement(Typography.Text, { color: 'colorGray9DarkBg' }, 'Aiden asks the right questions, collects photos or videos, and checks past work orders so the right tech \u2014 with the right parts \u2014 shows up the first time. '), React.createElement('br', null), React.createElement('br', null), React.createElement(Typography.Text, { color: 'colorGray9DarkBg' }, 'Aiden cuts work order creation time by 20%.')))),
    React.createElement(Flex, {
        key: 'step3',
        align: 'center',
        gap: 12,
        style: { padding: '48px 0 24px 10px' }
    }, React.createElement('img', {
        src: Step3Src,
        alt: '',
        style: { width: '191px' }
    }), React.createElement(Flex, {
        vertical: true,
        gap: 16
    }, React.createElement(Typography.Title, {
        level: 4,
        color: 'colorGray8TextDefault',
        style: {
            fontWeight: 500,
            fontFamily: '"Satoshi", sans-serif',
            lineHeight: '120%'
        }
    }, 'Personal help, tailored to ', React.createElement('b', { style: { color: '#090909' } }, 'you'), ' and ', React.createElement('b', { style: { color: '#090909' } }, 'your home')), React.createElement('div', {
        style: {
            paddingRight: '32px',
            lineHeight: 1
        }
    }, React.createElement(Typography.Text, { color: 'colorGray9DarkBg' }, 'Aiden remembers your home, past requests, and what\'s already been fixed \u2014 so you never have to repeat yourself. It helps prevent small issues from becoming major ones.'), React.createElement('br', null), React.createElement('br', null), React.createElement(Typography.Text, { color: 'colorGray9DarkBg' }, 'For urgent or complex issues, Aiden escalates to a human team member. '))))
];
export default CopilotGuide;